/**
 * Public Showcase catalog.
 *
 * Add a photograph by appending an object. Only items with published: true
 * appear on the public page. Leave creator empty unless a name is approved
 * for publication. Do not invent names, statistics, or project claims.
 *
 * Experience categories: Learning, Shooting, Editing, Creating,
 * Student Work, Behind the Scenes, Campus, Collaboration.
 *
 * Work filters: Photography, Video, Graphic Design, Animation, Other.
 */

const PUBLISHED = true

export const SHOWCASE_SECTIONS = [
  { id: 'learn', label: 'Learn' },
  { id: 'shoot', label: 'Shoot' },
  { id: 'edit', label: 'Edit' },
  { id: 'create', label: 'Create' },
  { id: 'show', label: 'Show' },
]

export const WORK_FILTERS = ['All', 'Photography', 'Video', 'Graphic Design', 'Animation', 'Other']

export const heroFrame = {
  src: '/Gallery/Academy/Creative Training Sessions/268A5754.JPG',
  alt: 'Students setting up a camera during a practical session at SMA',
  position: 'object-[center_30%]',
}

export const experienceFrames = {
  learn: [
    {
      id: 'learn-laptops',
      src: '/Gallery/Academy/Creative Training Sessions/DSC02423.jpg',
      alt: 'Students working on laptops during a class at SMA',
      caption: 'Class at SMA',
      category: 'Learning',
      position: 'object-center',
      ratio: '16 / 10',
      sort: 1,
      featured: true,
      published: PUBLISHED,
    },
    {
      id: 'learn-demo',
      src: '/Gallery/Academy/Learning In Action/DSC02406 copy.jpg',
      alt: 'An instructor demonstrating a camera to a student at SMA',
      caption: 'A demonstration in class',
      category: 'Learning',
      position: 'object-center',
      ratio: '4 / 5',
      sort: 2,
      featured: false,
      published: PUBLISHED,
    },
  ],
  shoot: [
    {
      id: 'shoot-crew',
      src: '/Gallery/Academy/Creative Training Sessions/268A5756.JPG',
      alt: 'An SMA crew setting up a camera on a location shoot',
      caption: 'On a location shoot',
      category: 'Shooting',
      position: 'object-[22%_center]',
      ratio: '16 / 10',
      sort: 1,
      featured: true,
      published: PUBLISHED,
    },
    {
      id: 'shoot-operator',
      src: '/Gallery/Academy/Workshops/1X4A5720.jpg',
      alt: 'A student standing with a camera on a tripod during an SMA workshop',
      caption: 'Camera in hand',
      category: 'Shooting',
      position: 'object-center',
      ratio: '3 / 4',
      sort: 2,
      featured: false,
      published: PUBLISHED,
    },
    {
      id: 'shoot-gimbal',
      src: '/Gallery/Academy/Workshops/1X4A5555.jpg',
      alt: 'A student holding a camera on a gimbal during an SMA workshop',
      caption: 'Working with a gimbal',
      category: 'Shooting',
      position: 'object-center',
      ratio: '3 / 4',
      sort: 3,
      featured: false,
      published: PUBLISHED,
    },
  ],
  edit: [
    {
      id: 'edit-timeline',
      src: '/Gallery/Academy/Workshops/ww.jpg',
      alt: 'A student editing with headphones at a workstation',
      caption: 'At the workstation',
      category: 'Editing',
      position: 'object-center',
      ratio: '16 / 10',
      sort: 1,
      featured: true,
      published: PUBLISHED,
    },
    {
      id: 'edit-stills',
      src: '/Gallery/Academy/Learning In Action/DSC02432 copy.jpg',
      alt: 'A student reviewing photographs on a laptop at SMA',
      caption: 'Reviewing stills',
      category: 'Editing',
      position: 'object-[30%_center]',
      ratio: '4 / 5',
      sort: 2,
      featured: false,
      published: PUBLISHED,
    },
  ],
  together: [
    {
      id: 'together-review',
      src: '/Gallery/Academy/Multimedia Workshops/DSC02588.jpg',
      alt: 'Students gathered around a camera during an SMA workshop',
      caption: 'Reviewing a shot together',
      category: 'Collaboration',
      position: 'object-[68%_center]',
      ratio: '16 / 10',
      sort: 1,
      featured: true,
      published: PUBLISHED,
    },
    {
      id: 'together-table',
      src: '/Gallery/Academy/Workshops/1X4A5553.jpg',
      alt: 'Students seated together during an SMA workshop',
      caption: 'In the room together',
      category: 'Collaboration',
      position: 'object-center',
      ratio: '3 / 4',
      sort: 2,
      featured: false,
      published: PUBLISHED,
    },
  ],
}

export const disciplines = [
  {
    id: 'photography',
    label: 'Photography',
    copy: 'Cameras, light, and pictures made on purpose.',
    href: '/programs?category=Photography',
    image: '/Gallery/Academy/showcase/Kampala City Scape.jpg',
    alt: 'A photographer framing the Kampala skyline',
  },
  {
    id: 'videography',
    label: 'Videography',
    copy: 'Movement, sound, and how a scene is covered.',
    href: '/programs?category=Video%20Production',
    image: '/Gallery/Academy/Creative Training Sessions/268A5756.JPG',
    alt: 'An SMA crew on a location shoot',
  },
  {
    id: 'graphic-design',
    label: 'Graphic Design',
    copy: 'Type, image, and ideas made visible.',
    href: '/programs?category=Graphic%20Design',
    image: '/Gallery/Academy/Creative Training Sessions/DSC02423.jpg',
    alt: 'Students working at laptops during class',
  },
  {
    id: 'animation',
    label: 'Animation',
    copy: 'Motion built frame by frame.',
    href: '/programs?category=Animation',
    image: null,
    alt: '',
  },
  {
    id: 'ai',
    label: 'AI for Creatives',
    copy: 'New tools inside a real creative workflow.',
    href: '/programs?category=AI%20%26%20Technology',
    image: null,
    alt: '',
  },
  {
    id: 'multimedia',
    label: 'Multimedia Production',
    copy: 'The full path from idea to finished piece.',
    href: '/programs?category=Multimedia',
    image: '/Gallery/Academy/Multimedia Workshops/DSC02588.jpg',
    alt: 'Students reviewing a camera together',
  },
]

export const showcaseWork = [
  {
    slug: 'kampala-city-scape',
    title: 'Kampala City Scape',
    filter: 'Photography',
    category: 'Student Work',
    src: '/Gallery/Academy/showcase/Kampala City Scape.jpg',
    alt: 'A photographer looking over the Kampala skyline toward the Gaddafi Mosque',
    caption: 'Kampala, from above.',
    description: 'A wide photograph of Kampala in late light.',
    creator: null,
    ratio: '16 / 10',
    sort: 1,
    featured: true,
    published: PUBLISHED,
    youtubeId: null,
  },
  {
    slug: 'studio-portrait',
    title: 'Studio portrait',
    filter: 'Photography',
    category: 'Student Work',
    src: '/Gallery/Academy/potrait series/DR. CHRISTINE (4).jpg',
    alt: 'A studio portrait against a dark background',
    caption: 'Studio portrait.',
    description: 'A controlled studio portrait.',
    creator: null,
    ratio: '4 / 5',
    sort: 2,
    featured: false,
    published: PUBLISHED,
    youtubeId: null,
  },
  {
    slug: 'product-portrait',
    title: 'Product portrait',
    filter: 'Photography',
    category: 'Student Work',
    src: '/Gallery/Academy/potrait series/Judith 2 copy.jpg',
    alt: 'A close portrait of a person holding a cosmetic bottle',
    caption: 'Portrait and product.',
    description: 'A portrait made with a product in frame.',
    creator: null,
    ratio: '4 / 5',
    sort: 3,
    featured: false,
    published: PUBLISHED,
    youtubeId: null,
  },
  {
    slug: 'kampala-reimagined',
    title: 'Kampala, reimagined',
    filter: 'Other',
    category: 'Student Work',
    src: '/Gallery/Academy/showcase/cyberpunk.jpg',
    alt: 'An illustrated Kampala street with neon signs, market stalls, and boda traffic',
    caption: 'A visual study of Kampala.',
    description: 'An illustrated take on a Kampala street.',
    creator: null,
    ratio: '16 / 9',
    sort: 4,
    featured: false,
    published: PUBLISHED,
    youtubeId: null,
  },
  {
    slug: 'academy-training-session',
    title: 'Academy training session',
    filter: 'Video',
    category: 'Student Work',
    src: 'https://i.ytimg.com/vi/35lUT3wQ_cE/hqdefault.jpg',
    alt: 'Still from an SMA training session',
    caption: 'Training in session.',
    description: 'A recording from an SMA training session.',
    creator: null,
    ratio: '16 / 9',
    sort: 5,
    featured: false,
    published: PUBLISHED,
    youtubeId: '35lUT3wQ_cE',
  },
]

export function publishedFrames(frames = []) {
  return frames.filter((frame) => frame.published !== false && frame.src).sort((a, b) => a.sort - b.sort)
}

export function publishedWork() {
  return showcaseWork
    .filter((item) => item.published !== false && (item.src || item.youtubeId))
    .sort((a, b) => a.sort - b.sort)
}

export function findWork(slug) {
  return publishedWork().find((item) => item.slug === slug) || null
}
